import React from 'react';
import {
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import Text from '../../../components/Text';

export default function LeadsEmploymentView(props) {
  return (
    <>
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="personalTitle">
              <Text value="How would you like to be addressed" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="personalTitle"
          id="personalTitle"
          value={props.formData.personalTitle}
          onChange={props.onChange}
          invalid={props.validations.personalTitle?.isInvalid}
        >
          <option value="">Select your title</option>
          <option key="MR" value="MR">Mr</option>
          <option key="MRS" value="MRS">Mrs</option>
          <option key="MISS" value="MISS">Miss</option>
          <option key="MS" value="MS">Ms</option>
        </Input>
        <FormFeedback>{ props.validations.personalTitle?.message }</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Row>
          <Col sm="auto" className="label-main">
            <Label htmlFor="maritalStatus">
              <Text value="What is your marital status" />
            </Label>
          </Col>
        </Row>
        <Input
          type="select"
          name="maritalStatus"
          id="maritalStatus"
          value={props.formData.maritalStatus}
          onChange={props.onChange}
          invalid={props.validations.maritalStatus?.isInvalid}
        >
          <option value="">Select your marital status</option>
          <option key="single1" value="1">Single</option>
          <option key="married2" value="2">Married</option>
          <option key="separated3" value="3">Separated</option>
          <option key="divorced4" value="4">Divorced</option>
          <option key="commonLaw5" value="5">Common Law</option>
          <option key="livingTogether6" value="6">Living Together</option>
          <option key="widowed7" value="7">Widowed</option>
          <option key="other8" value="8">Other</option>
        </Input>
        <FormFeedback>{ props.validations.maritalStatus?.message }</FormFeedback>
      </FormGroup>
    </>
  );
}
